import { FittingPracticeNavigationItem } from '../../../components/bearing-search/types/types';
import { handleActionError } from '../../utils/engineering-tools';
import { FittingPracticeNavigationMap } from './FittingForm';

export type FittingPracticeFormState = {
	applicationType: string;
	navigationMap: FittingPracticeNavigationMap;
	selections: Array<{
		selected?: FittingPracticeNavigationItem;
		list: FittingPracticeNavigationItem[];
	}>;
	isComplete: boolean;
};

export type FittingPracticeFormAction =
	| { type: 'change_option'; payload: [number, FittingPracticeNavigationItem | undefined] }
	| { type: 'reset'; payload: FittingPracticeFormState };

const fittingFormReducer: React.Reducer<
	FittingPracticeFormState,
	FittingPracticeFormAction
> = ( state, action ) => {
	switch ( action.type ) {
		case 'change_option': {
			const [ index, navigation ] = action.payload;

			if ( ! navigation ) {
				return {
					...state,
					isComplete: false,
				};
			}

			const selections = state.selections.slice( 0, index + 1 );
			selections[ index ].selected = navigation;
			const nextDropdown = state.navigationMap.get( navigation?.nextCategoryId );

			if ( nextDropdown ) {
				selections.push( { list: nextDropdown } );
			}

			return {
				...state,
				selections,
				isComplete: navigation.nextCategoryId === 'END',
			};
		}
		case 'reset': {
			return {
				...action.payload,
			};
		}
	}

	return handleActionError( action );
};

export default fittingFormReducer;
